<template>
  <footer class="footer" ref="footerSection">
    <div class="container">
      <div class="footer-top animate-scroll">
        <div class="footer-logo animate-scroll" @click="goToHome">
          <img src="@/assets/image/logo-white@2x.png" alt="闻讼咨询" class="logo">
        </div>
        
        <div class="footer-nav animate-scroll">
          <router-link to="/" class="nav-link">首页</router-link>
          <router-link to="/about" class="nav-link">走进闻讼</router-link>
          <router-link to="/business" class="nav-link">大型企业诉管服务</router-link>
<!--          <router-link to="/lawyers" class="nav-link">闻讼认证律师</router-link>-->
          <!-- <router-link to="/knowledge" class="nav-link">闻讼知识库</router-link> -->
          <router-link to="/overseas" class="nav-link">涉外服务</router-link>
          <router-link to="/cooperation" class="nav-link">商务合作</router-link>
          <router-link to="/join" class="nav-link">加入闻讼</router-link>
        </div>
      </div>
      
      <div class="footer-divider animate-scroll"></div>
      
      <div class="footer-contact animate-scroll">
        <!-- <div class="contact-item">010-88888888</div> -->
        <div class="contact-item">邮箱：business@wensonglaw.com</div>
        <div class="contact-item">地址：北京市东城区夕照寺中街4号epark大厦5层</div>
        <div class="contact-item"><a href="https://beian.miit.gov.cn/ww.chinabgao.com/#/Integrated/index" target="_blank">京ICP备2025131037号-1</a></div>
      </div>
    </div>
  </footer>
</template>

<script>
import { RouterLink } from 'vue-router';
export default {
  name: 'AppFooter',
  components: {
    RouterLink
  },
  mounted() {
    this.initScrollAnimations();
  },
  beforeUnmount() {
    // 清除观察者
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    initScrollAnimations() {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
      };
      
      if (this.$refs.footerSection) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const animatedElements = entry.target.querySelectorAll('.animate-scroll');
              animatedElements.forEach(el => {
                el.classList.add('visible');
              });
            }
          });
        }, options);
        
        this.observer.observe(this.$refs.footerSection);
      }
    },
    goToHome() {
      this.$router.push('/');
    }
  }
}
</script>

<style scoped>
/* 入场动画基础样式 */
.animate-scroll {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 1s ease, transform 1s ease;
}

.animate-scroll.visible {
  opacity: 1;
  transform: translateY(0);
}

/* 页脚样式 */
.footer {
  width: 1920px;
  background-image: url('~@/assets/image/footer-bg@2x.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.container {
  width: 1200px;
  margin: 0 auto;
  padding-top: 40px;
}

.footer-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.footer-logo {
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: opacity 0.3s;
}

.footer-logo:hover {
  opacity: 0.8;
}

.footer-logo img {
  width: 109px;
  height: 40px;
}

.footer-nav {
  display: flex;
  gap: 32px;
  flex-wrap: wrap;
}

.nav-link {
  color: #fff;
  text-decoration: none;
  font-size: 16px;
  transition: color 0.3s;
}

.nav-link:hover {
  color: #3578E5;
}

.footer-divider {
  width: 1200px;
  height: 1px;
  background: #FFFFFF;
  opacity: 0.2;
  margin-top: 40px;
  margin-bottom: 30px;
}

.footer-contact {
  display: flex;
  align-items: center;
  color: #FFFFFF;
  font-size: 16px;
  padding-bottom: 32px;
}

.contact-item:not(:last-child) {
  margin-right: 30px;
}
.contact-item a {
  color: #FFFFFF;
}
</style>
